import logger from '@/app/logger';
import axios from 'axios';

export const agencyNewsQuery_Client = async (agencyId: number) => {
  const url = `/api/agencies/${agencyId}/news`;
  logger.info(`Fetching agencyNews data: ${url}...`);
  return axios.get(url).then((res) => {
    logger.info('agencyNews: Got response');
    return res.data ?? [];
  });
};
